import React from 'react';
import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import Lobby                 from './pages/Lobby';
import ExperimentProcessing  from './pages/ExperimentProcessing';
import ExperimentList        from './pages/ExperimentList';
import ExperimentDetail      from './pages/ExperimentDetail';

const navLink = { color: '#94a3b8', textDecoration: 'none', padding: '6px 14px',
  borderRadius: 8, fontSize: 14, fontWeight: 500 };
const navActive = { ...navLink, background: '#1e293b', color: '#38bdf8' };

function Nav() {
  const { pathname } = useLocation();
  const l = (to) => (pathname === to ? navActive : navLink);
  return (
    <nav style={{ background: '#0f172a', borderBottom: '1px solid #1e293b',
      padding: '10px 24px', display: 'flex', alignItems: 'center', gap: 8 }}>
      <span style={{ fontWeight: 700, color: '#38bdf8', marginRight: 16, fontSize: 16 }}>
        ESP32 MQ Monitor
      </span>
      <Link to="/"           style={l('/')}>Lobby</Link>
      <Link to="/experiments" style={l('/experiments')}>ผลการทดลอง</Link>
    </nav>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Nav />
      <div style={{ padding: 24 }}>
        <Routes>
          <Route path="/"                         element={<Lobby />} />
          <Route path="/experiment/:id/running"   element={<ExperimentProcessing />} />
          <Route path="/experiments"              element={<ExperimentList />} />
          <Route path="/experiments/:id"          element={<ExperimentDetail />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}
